// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"30":"feedback","150":"amap","550":"msg","641":"bing"}[chunkId] || chunkId) + "." + {"30":"f74c637f","150":"6a1d2a5e","189":"29b2cace","550":"8f9de73a","641":"78e42b96"}[chunkId] + ".chunk.js";
};